let nextRowId = 0;

const createFormRowId = (prefix: string): string => {
  nextRowId += 1;
  return `${prefix}-${nextRowId}`;
};

export default createFormRowId;
